module.exports = __webpack_public_path__ + "static/img/app1@2x.70baa3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/app1@2x.png
// module id = KKrl
// module chunks = 2